export enum TypeDelivery {
  CourierDelivery = 'dostavka-kurerom',
  DeliveryByTransportCompany = 'dostavka-transportnoi-kompaniei',
  Pickup = 'samovyvoz-iz-sinnogo-centra',
}

export type DeliveryDescription = {
  code: TypeDelivery;
  description: string;
  name: string;
};

export interface DeliverySchema {
  deliveryDescriptionData?: DeliveryDescription[];
  isLoadingData: boolean;
}
